import { useConfigurationStore } from '@/stores/configuration';
import { getSafeMediaUrl } from '@/utils/media-url';

export function useSafeMediaUrl(src: Nullable<string>) {
  const fileEndpoint = useConfigurationStore((s) => s.endpoint.FILE_ENDPOINT);

  return {
    src: getSafeMediaUrl(src, fileEndpoint),
    fileEndpoint,
  };
}
